import {LIST, REQUEST_TO_CLOSE} from "./type";

const initalState = {
    invoiceList: [],
    ticketClosed:[]
};

const InvoiceModule = (state = initalState, action) => {
    const { type, payload } = action;
    switch (type) {
        case LIST:
            return {
                ...state,
                invoiceList: payload,
            }
        case REQUEST_TO_CLOSE:
            return {
                ...state,
                ticketClosed: payload,
            }
        default:
            return {
                ...state,
            };
    }
};

export default InvoiceModule;
